module.exports = __webpack_public_path__ + "img/orange logo.77adbc71.png";